<template>
  <div>
    <template v-for="row in products">
      <div
        class="row grid-table-row p-1 d-flex justify-content-between"
        :key="row.id"
      >
        <div class=" order-1  order-md-1 align-middle p-0 text-right ">
          {{ row.quantity | decimal }} x
        </div>
        <div class="col-8 order-md-2 align-middle p-0 ">
          {{ row.description }}
          <br />
          <small class="text-muted"> R$ {{ row.price | decimal }} </small>
        </div>
        <div class=" order-3 order-md-3 align-middle p-0 text-right ">
          R$ {{ setSubTotal(row) | decimal }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    components: {},

    props: {
      products: {}
    },

    data: () => ({}),

    computed: {},

    methods: {
      setSubTotal(row) {
        return row.price * row.quantity;
      }
    }
  };
</script>

<style>
</style>
